import React from 'react';
import './LinkToggle.scss';

function LinkToggle(props) {
    return <span className="form__link" onClick={props.onClick}>{props.title}</span>
}

export default LinkToggle;